import { Directive } from '@angular/core';
import { LayoutAlignDirective as FlexLayoutLayoutAlignDirective } from '@angular/flex-layout';

const inputs = [
  'flLayoutAlign',
  'flLayoutAlign.mobile',
  'flLayoutAlign.tablet',
  'flLayoutAlign.desktop-small',
  'flLayoutAlign.desktop-large',
  'flLayoutAlign.desktop-xlarge',
  'flLayoutAlign.desktop-xxlarge',
];

@Directive({
  selector: `
    [flLayoutAlign],
    [flLayoutAlign.mobile],
    [flLayoutAlign.tablet],
    [flLayoutAlign.desktop-small],
    [flLayoutAlign.desktop-large],
    [flLayoutAlign.desktop-xlarge],
    [flLayoutAlign.desktop-xxlarge],
  `,
  inputs,
})
export class LayoutAlignDirective extends FlexLayoutLayoutAlignDirective {
  protected inputs = inputs;
}
